import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-surface border-y border-border py-6" data-id="element-216">
      <div className="max-w-6xl mx-auto px-4" data-id="element-217">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-border" data-id="element-218">
          <div className="flex flex-col items-center justify-center" data-id="element-219">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-220">
              +2.000
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-221">
              Terapeutas ya lo tienen
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-222">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-223">
              1
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-224">
              Producto Principal completo
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-225">
            <span className="text-2xl md:text-4xl font-bold text-ink mb-1 font-serif" data-id="element-226">
              5
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-227">
              Bonos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-228">
            <div className="flex items-center justify-center mb-1" data-id="element-229">
              <span className="text-2xl md:text-4xl font-bold text-ink mr-2 font-serif" data-id="element-230">
                4.9/5
              </span>
              <div className="flex" data-id="element-231">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-gold fill-gold" data-id="element-232" />)}
              </div>
            </div>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-medium" data-id="element-233">
              Calificación
            </span>
          </div>
        </div>
      </div>
    </div>;
}